<template>
    <!--Le code HTML dans la balise template-->
    <div v-if="message!=null">
        <h1>{{message}} <router-link style="color:black;" :to="{name : 'Accueil'}">Connectez vous dès maintenant.</router-link></h1>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
import RequestManager from '../script/request';
    import config from "../config.js";
    export default defineComponent({
        components: {
            //Les composants
        },
        // Données du composant
        data: function () {
            return {
                message: null
            }
        },
        //Données calculé du composant
        computed: {
            //données calculé
        },
        //Méthodes et fonctions du 
        methods: {
        },

        // Variables  passées en paramétre
        props: {
            id: String
        },
        // fonction s'éxécurant lorsque le composant est monté
        // elle est exécuté avant la création du composant
        mounted() {
            var url = `${config.urlBackEndParent}api/Client/validerInscription/`;
            RequestManager.post(url, this.id)
                .then(response => {
                    if (response) {
                        this.message = 'La création de votre compte a été validée avec succès.';
                    }
                    else {
                        // validerInscription renvoie false si le compte est deja valide
                        // ou si le lien n'est plus valable. On affiche un message, on ne
                        // redirige PAS vers 'NotFound' (route commentee -> plantait le rendu).
                        this.message = "Ce compte est deja valide, ou ce lien de validation n'est plus valable.";
                    }
                })
                .catch(error => {
                    console.error("Erreur validation inscription :", error);
                    this.message = "La validation a echoue : " + RequestManager.decrireErreur(error);
                });
        }
        ,
        // fonction s'éxécutant lorsque le composant est crée
        // elle est exécuté avant le rendu du composant
        created() {

        }
    });
</script>